// biome-ignore-all lint/suspicious/noArrayIndexKey: Parsed text has no item identity or component state; repeated lines and URLs are intentional.
import { informationBlocks, informationTextParts } from "../../../shared/tournament-information";

/** User content stays text; only safe web links and bullet lists gain markup. */
export function InformationText({ text }: { text: string }) {
  const inline = (line: string) =>
    informationTextParts(line).map((part, i) =>
      part.href ? (
        <a
          key={`${i}:${part.href}`}
          href={part.href}
          target="_blank"
          rel="noopener noreferrer"
          className="break-words text-brand-ink underline underline-offset-4 hover:decoration-2"
        >
          {part.text}
        </a>
      ) : (
        part.text
      ),
    );
  return (
    <div className="min-w-0 space-y-3 break-words text-sm leading-relaxed [overflow-wrap:anywhere]">
      {informationBlocks(text).map((block, i) =>
        block.kind === "list" ? (
          <ul key={`${i}:${block.kind}`} className="list-disc space-y-1 pl-5">
            {block.lines.map((line, j) => (
              <li key={`${j}:${line}`}>{inline(line)}</li>
            ))}
          </ul>
        ) : (
          <p key={`${i}:${block.kind}`} className="whitespace-pre-wrap">
            {inline(block.lines.join("\n"))}
          </p>
        ),
      )}
    </div>
  );
}
